import { X, CheckCircle2, MapPin } from 'lucide-react';

export const PurchaseNotification = ({ show, notification, onClose }) => {
  if (!show || !notification) return null;

  return (
    <div className="purchase-toast" data-testid="purchase-notification">
      <div className="flex items-center gap-2.5">
        {/* Ícone discreto */}
        <div className="flex-shrink-0 w-7 h-7 bg-green-100 rounded-full flex items-center justify-center">
          <CheckCircle2 className="h-4 w-4 text-green-700" />
        </div>

        {/* Conteúdo compacto */}
        <div className="flex-1 min-w-0">
          <p className="text-xs text-neutral-800 leading-tight">
            <span className="font-medium">{notification.customer_name}</span>
            {' '}comprou
          </p>
          <p className="text-xs text-neutral-500 truncate leading-tight">
            {notification.product_name}
          </p>
          <div className="flex items-center gap-1 text-[10px] text-neutral-400">
            <MapPin className="h-2.5 w-2.5" />
            <span>{notification.city}</span>
          </div>
        </div>

        {/* Botão fechar */}
        <button
          onClick={onClose}
          className="flex-shrink-0 p-1 hover:bg-neutral-100 rounded transition-colors"
          data-testid="notification-close-btn"
          aria-label="Fechar"
        >
          <X className="h-3 w-3 text-neutral-400" />
        </button>
      </div>
    </div>
  );
};

export default PurchaseNotification;
